<template>
  <div class="swiper_bg6" id="Honor6">
    <!-- 右上角文字介绍 -->
    <div class="text-content">
      <!-- 切换按钮 -->
      <div class="swiper-controls">
        <div class="control-btn prev-btn" @click="slideToPrev">
          <img src="../../../static/img/green-left.png" alt="Previous" />
        </div>
        <div class="control-btn next-btn" @click="slideToNext">
          <img src="../../../static/img/green-right.png" alt="Next" />
        </div>
      </div>
      <p class="swiper_description" v-if="getCurrentDescription()">
        {{ getCurrentDescription() }}
      </p>
    </div>
    <div class="middle_banner6">
      <div class="swiper-container mySwiper mySwiper6" id="mySwiper6">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in zzry" :key="index">
            <div class="slide-img-wrapper">
              <img class="book6_img" :src="item.image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from "@/api/index";
import Swiper, { Pagination } from "swiper";
Swiper.use(Pagination);
import "swiper/swiper-bundle.css";
import {getDepartmentBannerList} from "../../api";
export default {
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  watch: {
    //监听轮播数据变化后再创建实例
    zzry() {
      this.$nextTick(() => {
        let that = this;
        this.swiper = new Swiper(".mySwiper6", {
          centeredSlides: true,
          loop: true,
          // autoplay: {
          //   disableOnInteraction: false,
          //   delay: 3000,
          // },
          on: {
            slideChange: function () {
              that.changetext(this.realIndex);
            },
          },
          breakpoints: {
            "@0.00": {
              slidesPerView: 1.2,
              spaceBetween: 0,
            },
            "@0.75": {
              slidesPerView: 3.5,
              spaceBetween: 0,
            },
            "@1.00": {
              slidesPerView: 3.5,
              spaceBetween: 0,
            },
            "@1.25": {
              slidesPerView: 3.5,
              spaceBetween: 0,
            },
          },
        });
      });
    },
  },
  data() {
    return {
      bannertextCn: "",
      bannertextEn: "",
      bannertextEs: "",
      zzry: [],
      swiper: Object,
    };
  },
  mounted() {
    this.getInfo();
  },
  beforeDestroy() {},
  created() {},
  methods: {
    getInfo() {
      API.getDepartmentBannerList({page: 1, limit: 100})
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list) {
              this.zzry = res.page.list;
              // 初始化显示第一个项目的标题
              if (this.zzry.length > 0) {
                this.changetext(0);
              }
            }
          })
          .catch(() => {
          });
    },
    changetext(i) {
      this.bannertextCn = this.zzry[i].contentCn;
      this.bannertextEn = this.zzry[i].contentEn;
      this.bannertextEs = this.zzry[i].contentEs;
    },
    getCurrentDescription() {
      if (this.$i18n.locale === 'zh') {
        return this.bannertextCn;
      } else if (this.$i18n.locale === 'es') {
        return this.bannertextEs || this.bannertextEn;
      }
      return this.bannertextEn;
    },
    slideToNext() {
      this.swiper.slideNext();
    },
    slideToPrev() {
      this.swiper.slidePrev();
    },
  },
};
</script>
<style lang="stylus" scoped>
.mySwiper6 {
  width: 100%;
  height: 100%;
  padding-bottom: 2rem;

}
// 切换按钮样式
.swiper-controls {
  margin-top: 8rem;
  display: flex;
  gap: 15px;
  z-index: 20;
}

.control-btn {
  width: 4rem;
  height: 4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  img {
    width: 100%;
    height: 100%;
  }
}

// 右上角文字内容
.text-content {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  z-index: 15;
  transition: all 0.5s ease;
  margin: 0 12.5%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  p{
    max-width: 40%;
    margin-right: 25%;
  }
}

.swiper_title {
  font-family: demibold, sans-serif;
  font-size: 2.6rem;
  text-align: left;
  margin: 0 0 1.5rem 0;
  color: #333;
  line-height: 1.3;
}

.swiper_description {
  font-family: regular;
  font-size: 2.2rem;
  line-height: 3rem;
  color: white;
  text-align: left;
  margin: 0;
}

.page_btn_div {
  display: flex;

  img {
    width: 5rem;
    height: 5rem;
    margin: 0 1rem;
    cursor: pointer;
  }

  .prev {
    cursor: pointer;
    width: 5rem;
    height: 5rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('../../../static/img/swiper_left.png');

    &:hover {
      background-image: url('../../../static/img/swiper_left2.png');
    }
  }

  .next {
    cursor: pointer;
    margin-left: 1rem;
    width: 5rem;
    height: 5rem;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('../../../static/img/swiper_right.png');

    &:hover {
      background-image: url('../../../static/img/swiper_right2.png');
    }
  }
}

.book6_img {
  transition: 300ms;
  width: 100%;
  height: 100%;
  object-fit: cover;
  //border-radius: 1rem;
}

.swiper_bg6 {
  //background: #f5f5f5;
  position: relative;
  height: 70rem;
}

.bannerright {
  width: 8rem;
  cursor: pointer;
  z-index: 99;
  padding: 5rem 3rem;
  border-radius: 6px;
}

.bannerleft {
  width: 8rem;
  cursor: pointer;
  z-index: 99;
  padding: 5rem 3rem;
  border-radius: 6px;
}

.bannerleft:hover, .bannerright:hover {
  background: rgba(0, 0, 0, 0.05);
}

.swiper-button-prev {
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 10rem;
  height: 10rem;
  outline: none;
}

.swiper-button-next {
  color: transparent;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
  width: 10rem;
  height: 10rem;
  outline: none;
}

.mySwiper {
  width: 100%;
  margin-bottom: 0;
  position: relative;
}

.middle_banner6 {
  //max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
}

.swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transition: all 0.4s ease;
  border-radius: 1.6rem;
  padding: 0;
  box-sizing: border-box;
  transform: scaleX(0.8) scaleY(0.7);
  transform-origin: center bottom;
  //box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.1);
  overflow: hidden;
  //height: 50rem;
}

.swiper-slide-prev {
  transform: scale(1);
  transform-origin: center bottom;
  z-index: 10;
  box-shadow: 5px 5px 10px 4px rgba(0, 0, 0, 0.16);
  //box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.15);
}

.slide-img-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  //border-radius: 1rem;
}

.swiper-pagination {
  display: none;
}

@media screen and (max-width: 1200px) {
  .mySwiper {
    margin-bottom: 5rem;
  }

  .swiper-controls {
    top: -60px;
  }

  .control-btn {
    width: 4rem;
    height: 4rem;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .swiper_description {
    font-size: 1.2rem;
  }

  .page_btn_div {
    display: none;
  }

  .swiper-pagination {
    display: block;
    bottom: -3rem;
  }

  .swiper-slide {
    transform: scale(0.85);
    padding: 1rem;
  }

  .swiper-slide-active {
    transform: scale(1);
  }

  .slide-img-wrapper {
    height: 28rem;
  }

  .middle_banner6 {
    width: 100%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  .bannerleft,
  .bannerright {
    width: 1rem;
    padding: 0;
  }
}

@media screen and (max-width: 768px) {
  .swiper_bg6 {
    padding: 3rem 0;
    height: 50rem;
  }

  .swiper-controls {
    top: -50px;
    gap: 10px;
    margin-top: 0;
  }

  .text-content {
    position: static;
    max-width: 100%;
    padding: 2rem;
    margin: 0;
    text-align: center;
    p{
      margin-left: 1rem;
      max-width: 100%;
      text-align: left;
    }
  }
  .control-btn{
    width: 3rem;
    height: 3rem;
  }
  .swiper_title {
    font-size: 1.6rem;
    text-align: center;
  }

  .swiper_description {
    font-size: 1.1rem;
    text-align: center;
    margin-right: 0 !important;
    line-height: 1.5;
  }

  .swiper-slide {
    transform: scale(0.9);
    padding: 0;
  }

  .slide-img-wrapper {
    height: 22rem;
  }
}
</style>
